<template>
  <nav
    class="pagination is-hoverable is-medium is-spaced is-centered"
    role="navigation"
    aria-label="pagination"
  >
    <ul class="pagination-list">
      <template v-if="links?.previous !== null && links !== null">
        <li class="is-hidden-mobile">
          <button
            class="pagination-link rj-pagination-btn"
            aria-label="First page"
            @click="getFirstPage()"
            >First</button
          >
        </li>
        <li>
          <button
            class="pagination-link rj-pagination-btn"
            aria-label="Previous page"
            @click="changePage(content.current - 1)"
            >Previous</button
          >
        </li>
      </template>
      <li>
        <span
v-if="content !== null"
class="pagination-link rj-pagination-btn"
aria-current="page"
:aria-label="'Page ' + content.current + ' of ' + content.last_page"
          >Page {{ content.current }} of {{ content.last_page }}</span
        >
        <span
v-else
class="pagination-link rj-pagination-btn"
aria-current="page"
aria-label="Page 1 of 1">Page 1 of 1</span>
      </li>
      <template
        v-if="links !== null && links.next !== null && content !== null && content.current !== content.last_page"
      >
        <li>
          <button
            class="pagination-next rj-pagination-btn"
            aria-label="Next page"
            @click="changePage(content.current + 1)"
            >Next</button
          >
        </li>
        <li class="is-hidden-mobile">
          <button
            class="pagination-link rj-pagination-btn"
            aria-label="Last page"
            @click="getLastPage()"
            >Last</button
          >
        </li>
      </template>
    </ul>
  </nav>
</template>
<script setup lang="ts">
interface PaginationLinks {
  next: string | null
  previous: string | null
}

interface PaginationContent {
  current: number
  last_page: number
}

const props = defineProps<{
  links: PaginationLinks | null
  content: PaginationContent | null
}>()

const emit = defineEmits<{
  getJobs: [page: number]
}>()

function changePage(page: number) {
  if (page !== props.content?.current) {
    emit("getJobs", page)
  }
}

function getFirstPage() {
  emit("getJobs", 1)
}

function getLastPage() {
  if (props.content) {
    emit("getJobs", props.content.last_page)
  }
}
</script>
